
    <template>
    <svg viewBox="0 0 26 26" xmlns="http://www.w3.org/2000/svg">
  <rect
    opacity="0.01"
    fill="black"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M5.5 12C6.32842 12 7 12.6716 7 13.5C7 14.3284 6.32842 15 5.5 15C4.67158 15 4 14.3284 4 13.5C4 12.6716 4.67158 12 5.5 12ZM20.5 12C21.3284 12 22 12.6716 22 13.5C22 14.3284 21.3284 15 20.5 15C19.6716 15 19 14.3284 19 13.5C19 12.6716 19.6716 12 20.5 12ZM14.5 13.5C14.5 12.6716 13.8284 12 13 12C12.1716 12 11.5 12.6716 11.5 13.5C11.5 14.3284 12.1716 15 13 15C13.8284 15 14.5 14.3284 14.5 13.5Z"
    fill="currentColor"
  />
</svg>

    </template>

    <script lang="ts">
    import type { DefineComponent } from 'vue'
    export default ({
      name: 'More',
    }) as DefineComponent
    </script>
    